// extracted by mini-css-extract-plugin
export default {"heading":"HpHeading_heading__dbKrw","heading-vector":"HpHeading_heading-vector__jRMrb","sub-heading":"HpHeading_sub-heading__KUrew"};